module.exports = __webpack_public_path__ + "img/type_4.57139524.png";